import { useEffect, useState } from "react";
import api from "../lib/api";
import { Send, Trash2, Copy } from "lucide-react";
import { toast } from "sonner";

export default function AdminTelegram() {
  const [subs, setSubs] = useState([]);
  const [bot, setBot] = useState(null);

  const load = () => api.get("/telegram/subscribers").then((r) => setSubs(r.data || []));
  useEffect(() => {
    load();
    api.get("/telegram/bot-info").then((r) => setBot(r.data)).catch(() => {});
  }, []);

  const remove = async (id) => {
    if (!window.confirm("Remove this subscriber?")) return;
    await api.delete(`/telegram/subscribers/${id}`);
    toast.success("Removed");
    load();
  };

  const copyLink = () => {
    if (bot?.link) {
      navigator.clipboard.writeText(bot.link);
      toast.success("Bot link copied");
    }
  };

  return (
    <div data-testid="admin-telegram-page">
      <h1 className="font-serif-display text-4xl text-[#5979A9] mb-2 flex items-center gap-2"><Send size={24}/> Telegram Notifications</h1>
      <p className="text-[#4A5568] text-sm mb-7 max-w-2xl">Every reservation request is sent to every active subscriber below. To subscribe a new device or person, open the bot and tap <strong>/start</strong>.</p>

      {bot && bot.configured && bot.link && (
        <div className="bg-white border border-[#F0EAE6] rounded-2xl p-5 mb-7 max-w-2xl">
          <div className="text-xs uppercase tracking-[0.2em] text-[#5979A9]/80 mb-2 font-semibold">Subscribe link</div>
          <div className="flex items-center gap-3 flex-wrap">
            <a href={bot.link} target="_blank" rel="noopener noreferrer" className="font-mono text-[#E05947] underline" data-testid="bot-link">{bot.link}</a>
            <button onClick={copyLink} className="text-xs px-3 py-1.5 rounded-full bg-[#FAF4F1] hover:bg-[#F0EAE6] flex items-center gap-1"><Copy size={12}/> Copy</button>
          </div>
          <p className="text-xs text-[#4A5568] mt-3">Open this link on any phone, tap <strong>Start</strong>, and that account will instantly start receiving reservation notifications. Tap <code className="bg-[#FAF4F1] px-1.5 py-0.5 rounded">/stop</code> to unsubscribe.</p>
        </div>
      )}

      <h2 className="font-serif-display text-2xl text-[#5979A9] mb-4">Subscribers ({subs.filter((s) => s.is_active).length} active)</h2>
      {subs.length === 0 ? (
        <p className="text-sm text-[#4A5568] bg-white border border-[#F0EAE6] rounded-2xl p-6">No subscribers yet. Open the bot link above and tap /start.</p>
      ) : (
        <div className="bg-white border border-[#F0EAE6] rounded-2xl overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-[#FAF4F1] text-[#5979A9]">
              <tr>
                <th className="text-left px-5 py-3">Name</th>
                <th className="text-left px-5 py-3">Username</th>
                <th className="text-left px-5 py-3">Chat ID</th>
                <th className="text-left px-5 py-3">Status</th>
                <th className="text-left px-5 py-3">Subscribed</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {subs.map((s) => (
                <tr key={s.chat_id} className="border-t border-[#F0EAE6]" data-testid={`subscriber-row-${s.chat_id}`}>
                  <td className="px-5 py-3 font-medium">{[s.first_name, s.last_name].filter(Boolean).join(" ") || "—"}</td>
                  <td className="px-5 py-3 text-[#4A5568]">{s.username ? `@${s.username}` : "—"}</td>
                  <td className="px-5 py-3 font-mono text-xs">{s.chat_id}</td>
                  <td className="px-5 py-3">
                    {s.is_active
                      ? <span className="text-xs px-2 py-1 rounded-full bg-green-100 text-green-700 font-semibold">Active</span>
                      : <span className="text-xs px-2 py-1 rounded-full bg-gray-100 text-gray-600 font-semibold">Stopped</span>}
                  </td>
                  <td className="px-5 py-3 text-xs text-[#4A5568]">{(s.subscribed_at || "").slice(0,10)}</td>
                  <td className="px-5 py-3 text-right">
                    <button onClick={() => remove(s.chat_id)} className="text-[#E05947]"><Trash2 size={14}/></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
